module.exports = __webpack_public_path__ + "static/img/g2.e08d608.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vip/g2.svg
// module id = j95f
// module chunks = 0